import { useDispatch } from "react-redux"
import { ideaModelDataActions } from "../../store/ideaModelData"

export const TrendingCard = ({ image,name, votesCount, commentCount, ideaId }) => {
    const dispatch = useDispatch()
    
    return (
        <>
            <hr className="border-blue-starshot" />
            <div className="employee-task d-flex justify-content-between align-items-center">
                <div className="media">
                    <div className="starshot-ring mr-1" data-toggle="modal" data-target="#tideas" role="button" onClick={() => dispatch(ideaModelDataActions.setId(ideaId))}>
                        <div className="avatar">
                            <div className="text-icon font-lato">{name[0]}</div>
                        </div>
                    </div>
                    <div className="media-body my-auto">
                        <p className="mb-0 font-lato">{votesCount} Upvotes</p>
                        <p className="mb-0 font-lato font-10 star-orange">{commentCount} comments</p>
                    </div>
                </div>
                <a
                    className="d-flex align-items-center text-starshot"
                    data-toggle="modal" data-target="#tideas" role="button"

                    onClick={() => dispatch(ideaModelDataActions.setId(ideaId))}
                >
                    <i className="fas fa-ellipsis-h" />
                </a>
            </div>
        </>
    )
}